module.exports = __webpack_public_path__ + "static/trending-temps-thumbnail-232e896cd0bb5698b43fddd9f2ef8096.png";